import { cloneElement, useEffect, type ReactElement, type HTMLAttributes, type ReactNode } from 'react';
import { AnimatePresence, usePresence } from 'motion/react';
import { useMotionPolicy } from './Motion';

function ModalFrame({ children }: { children: ReactElement<HTMLAttributes<HTMLElement>> }) {
  const [present, remove] = usePresence();
  const { instant } = useMotionPolicy();
  useEffect(() => {
    if (present) return;
    if (instant) { remove?.(); return; }
    const timer = window.setTimeout(() => remove?.(), 160);
    return () => window.clearTimeout(timer);
  }, [present, instant, remove]);
  return cloneElement(children, {
    className: `${children.props.className ?? ''}${!present ? ' modal-is-exiting' : ''}`,
    inert: !present || children.props.inert,
    'aria-hidden': !present || children.props['aria-hidden'],
    style: { ...children.props.style, pointerEvents: present ? children.props.style?.pointerEvents : 'none' },
  });
}

export function ModalPresence({ children }: { children: ReactNode }) {
  return <AnimatePresence>{children ? <ModalFrame key="dialog">{children as ReactElement<HTMLAttributes<HTMLElement>>}</ModalFrame> : null}</AnimatePresence>;
}
